import { useAppSelector } from 'app/hooks';
import AlertModal from 'components/common/AlertModal';
import FeatureTitleBar from 'components/common/FeatureTitleBar';
import useGlobalModal from 'components/common/GlobalModal/useGlobalModal';
import { SubGenre } from 'features/SubGenre/models/SubGenre';
import { selectIsEditMode } from 'features/common/editModeSlice';
import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import 'react-datepicker/dist/react-datepicker.css';
import { useTranslation } from 'react-i18next';
import './Detail.scss';
import SubGenreFormDetail from './components/SubGenreFormDetail';
import service from './services';

interface EditModalInterface {
  id: string;
  show: boolean;
  handleCloseModalEdit: () => void;
  dataTable?: SubGenre[];
  setDataTable?: (dataTable: SubGenre[] | []) => void;
}

function DetailModal({ id, show, handleCloseModalEdit, dataTable, setDataTable }: EditModalInterface) {
  const { t } = useTranslation();
  const [subGenre, setSubGenre] = useState<SubGenre>();
  const { showGlobalModal } = useGlobalModal();

  // selectors
  const isEditMode = useAppSelector(selectIsEditMode);

  useEffect(() => {
    const getSubGenre = async (id: string) => {
      await service
        .getSubGenre(id)
        .then((data) => {
          return data.data;
        })
        .then((data) => {
          setSubGenre(data);
        });
    };
    if (id) {
      getSubGenre(id).catch(() => {
        showGlobalModal &&
          showGlobalModal(() => (
            <AlertModal title={t('SubGenre.Validator.error')} message={t('Genre.Validator.500')}></AlertModal>
          ));
      });
    }
  }, [id, showGlobalModal, t]);

  return (
    <Modal show={show} onHide={handleCloseModalEdit} size="lg">
      <Modal.Header closeButton className={isEditMode ? 'reedit-mode-wrapper' : ''}>
        <FeatureTitleBar title={t('SubGenre.Form.title')} />
      </Modal.Header>
      <Modal.Body className={isEditMode ? 'reedit-mode-wrapper' : ''}>
        {subGenre && (
          <SubGenreFormDetail
            subGenre={subGenre}
            id={id}
            handleCloseModalEdit={handleCloseModalEdit}
            dataTable={dataTable}
            setDataTable={setDataTable}
          />
        )}
      </Modal.Body>
    </Modal>
  );
}
export default DetailModal;
